import { Characteristic, User } from '../models';
import { HasId } from '../interfaces';

export class UserScore implements HasId {
    public id: number;
    public user?: User;
    public userId: number;
    public characteristic?: Characteristic;
    public characteristicID: number;
    public score: number;
    public overriden: boolean;
}


// WEBPACK FOOTER //
// ./src/models/UserScore.tsx